import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { cacheService } from '../services/cacheService';

export const useAuthCheck = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      const auth = await cacheService.getCachedAuth();
      if (!auth || !auth.token) {
        navigate('/login');
      }
    };

    checkAuth();
  }, [navigate]);
}; 